import React, { useState, useEffect } from 'react'
import config from 'config';
import NoticeboardAPICall from 'NoticeboardAPICall';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import Notices from './Notices/Notices';
import { Add } from '@mui/icons-material';
import PostNotice from 'NOTICEBOARD/Components/PostNotice/PostNotice'
import RouteMenu from 'NOTICEBOARD/CommonResources/RoutingMenu/RouteMenu';
import { toast } from 'react-toastify';

let accessApiPath = '/api/instructor/noticeboard.php';

const ManageNotice = () => {

    //FOR DATA CONTROL
    const [isNewNoticeAdded, setIsNewNoticeAdded] = useState(false);

    // STATE FOR SHOW SIDE BAR POST NOTICE 
    const [showSideBarPostNotice, setShowSideBarPostNotice] = useState(false);
    
    // STATE FOR SHOW UPDATE DATA
    const [updateData, setUpdateData] = useState({
        "institute_id": '',
        "unique_id": "",
        "title": "",
        "description": "",
        "category_id": "",
        "department_array": "",
        "date": "",
        "aca_yr": "",
        "display_on_website": "",
        "posted_by": "",
    });

    // STATE FOR NOTICE EDIT MODE 
    const [editMode, setEditMode] = useState(false)
    const [instituteDepartment, setInstituteDepartment] = useState({})

    // HOOKS FOR GET ASSIGN ACCESS API CALL 
    useEffect(() => {
         apiCallToGetInstituteDepartment()
    }, []);

    // STATE FOR ADMIN ACCESS FOR MANAGE NOTICE AND MANAGE CATEGORY
    const [adminData, setAdminData] = useState([]);
    const [manageNoticeAccess, setManageNoticeAccess] = useState({});
    const [manageCategoryAccess, setManageCategoryAccess] = useState({});
    const [isNoticeBoardAdmin, setIsNoticeAdmin] = useState(false);
    const [isCategoryAdmin, setIsCategoryAdmin] = useState(false);

    // STATE FOR SUCCESS MODAL FOR MANAGE NOTICE
    const [successModalDetails, setSuccessModalDetails] = useState({
        successModal: false,
        successModalType: '',
        successMessage: ''
    });

    //RUN AFTER ADDING A NEW NOTICE
    const runAfterAddingANewNotice = () => setIsNewNoticeAdded(prevState => !prevState);

    // METHOD FOR GET ASSIGN ACCESS
    const apiCallToGetAccessDetails = async () => {
        let requestData = {
            institute_id: config.institute_id,
            user_id: config.faculty_id,
            stream_id: config.stream_id
        };


        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'GetNoticeBoardAccessDetails',
            requestData,
            accessApiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetAccessDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.access_provided;
                setAdminData(apiResult.admin.accessGrantedTo)
                setIsCategoryAdmin(apiResult.manage_notice_category.isAccessGranted == 'false' ? false : true);
                setManageCategoryAccess(apiResult.manage_notice_category.accessGrantedTo);
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while providing assign access. Please contact.'
                });
            }
        }
    }
    const apiCallToGetInstituteDepartment = async () => {
        setInstituteDepartment({})
        let requestData = {
            institute_id: config.institute_id,
        };


        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'getDepartmentsListWithoutPagination',
            requestData,
            "/api/instructor/instituteDepartments.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetInstituteDepartment()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data
                setInstituteDepartment(apiResult)
               
            } else {
                toast.error("Something went wrong while getting institute department. Please contact.")
            }
        }
    }

    // METHOD TO VIEW WARNING
    const viewWarning = () => {
        if (manageCategoryAccess.length > 0) {
            let adminNames = [];
            manageCategoryAccess.map(access => {
                adminNames.push(access.name);
            });

            setSuccessModalDetails({
                successModal: true,
                successModalType: 'warning',
                successMessage: `Access granted to  ${adminNames.join(', ')}.`
            });
        } else {
            let categoryAccess = [];
            adminData &&
                Object.values(adminData).map(access => {
                    categoryAccess.push(access.adminName);
                });
            setSuccessModalDetails({
                successModal: true,
                successModalType: "warning",
                successMessage: 'Access is not granted to anyone. Please contact ' + categoryAccess.toString() + ' for more details.'
            });
        }
    }

    // METHOD TO GET MESSAGE FROM POST NOTICE
    const getMessage = (message) => {
        setSuccessModalDetails({
            successModal: true,
            successModalType: 'success',
            successMessage: message
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    const closeSuccessModal = () => {
        setSuccessModalDetails({
            successModal: false,
            successModalType: "",
            successMessage: ""
        })
    }

    return (
        // ROUTING LINKS FOR NOTICE BOARD DASHBOARD AND MANAGE NOTICE
        <>
            {/* <div className="sideMenu" style={{ padding: 0 }}>
                <RouteMenu activeScreen="notice" />
            </div> */}
            <div className="noticeComponents p-0">
                <div className='row'>
                    <div className="col-md-6 col-sm-12 d-flex justify-content-start align-items-center">
                        <h4>Post Notice</h4>
                    </div>
                    <div className='col-md-6 col-sm-12' style={{ paddingRight: '10px' }}>
                        <div className="d-flex justify-content-end align-items-center">
                            <button className='btn btn-primary' onClick={() => { setShowSideBarPostNotice(true); setEditMode(false); }}>
                                <Add /> Post Notice
                            </button>
                        </div>
                    </div>
                </div>

                {/* RENDER NOTICES COMPONENT */}
                <div className='px-2'>
                    <Notices isNewNoticeAdded={isNewNoticeAdded} instituteDepartment = {instituteDepartment} />
                </div>
            </div>

            {/* sidebar for Post Notice */}
            {
                showSideBarPostNotice && 
                    <PostNotice 
                        updateData={updateData} 
                        editMode={editMode}
                        getMessage={getMessage}
                        setPostNotice={setShowSideBarPostNotice} 
                        noticeAdded={runAfterAddingANewNotice}
                    />
            }

            {/* SUCCESS MODAL FOR MANAGE NOTICE */}
            {
                successModalDetails.successModal &&
                    <SuccessModal
                        successModal={successModalDetails.successModal}
                        successModalType={successModalDetails.successModalType}
                        successMessage={successModalDetails.successMessage}
                        closeSuccessModal={closeSuccessModal}
                    />
            }
        </>
    );
}

export default ManageNotice;
